import { rest } from 'msw';
import chargeDetails from '@/mocks/data/fundingChargeDetailsData.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { IChargeDetails } from '@/domains/funding/activity.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const chargeDetailsHandler = rest.get<IChargeDetails>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_ACTIVITY_CHARGE_DETAILS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { charge_uuid } = req.params as { charge_uuid: string };

    const mockResponse = chargeDetails.find(
      (charge) => charge.charge_id === charge_uuid,
    ) as IChargeDetails | undefined;

    if (!mockResponse) {
      return res(
        ctx.status(404),
        ctx.json({ detail: 'Charge details not found' }),
      );
    }

    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
